/**
 * Marks anchor links in Header Nav as 'active'.
 *
 * Listens to events dispatched from SecondaryNavItems component.
 */
const NavAnchorLinkUpdater = {
  _selectors: {
    navAnchorLink: '.js-nav-anchor-link'
  },

  init() {
    window.addEventListener('scrolled-anchor-content', this.setActiveAnchorLink.bind(this));
  },

  setActiveAnchorLink(e) {
    document.querySelectorAll(this._selectors.navAnchorLink).forEach(node => {
      const dataUrlPath = node.getAttribute('data-url-path');

      // Found item
      if ( dataUrlPath.indexOf('#' + e.detail.anchoredElementId) !== -1 ) {
        node.classList.add('current');
      } else {
        node.classList.remove('current');
      }
    });
  }
};

export default NavAnchorLinkUpdater;
